import { render, staticRenderFns } from "./TemplateSelection.vue?vue&type=template&id=51605914&scoped=true&"
import script from "./TemplateSelection.vue?vue&type=script&lang=js&"
export * from "./TemplateSelection.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSelection.vue?vue&type=style&index=0&id=51605914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51605914",
  null
  
)

export default component.exports